import React, { useState } from 'react';
import { Form } from 'antd';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import the Quill styles


export default function CustomTextArea(props) {
  const [value, setValue] = useState('');

  const handleChange = (content) => {
    setValue(content);
    if (props.onChange) {
      props.onChange(content);
    }
  };

  
    const modules = {
        toolbar: [
        ['bold', 'italic'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }]
        ]
    };


  return (
    <Form.Item
      name={props.name}
      className='custom-input style-textarea'
      rules={[
        {
          type: props.type,
          message: props.message,
        },
      ]}
    >
      <ReactQuill
        value={value}
        onChange={handleChange}
        placeholder={props.message}
        modules={modules}
        {...props}
      />
    </Form.Item>
  );
}
